import { useState, useEffect } from "react";
import { Layout, Menu } from "antd";
import { Link, useLocation } from "react-router-dom";
import { sidebarItems } from "./SideBarData";

const { Sider } = Layout;
const { SubMenu } = Menu;

const Sidebar = () => {
  const location = useLocation();
  const [openKeys, setOpenKeys] = useState([]);

  const findSelectedKey = (items, path) => {
    for (const item of items) {
      if (item.url === path) {
        return item.id.toString();
      }
      if (item.children) {
        const childKey = findSelectedKey(item.children, path);
        if (childKey) {
          return childKey;
        }
      }
    }
    return null;
  };

  const selectedKey = findSelectedKey(sidebarItems, location.pathname);

  useEffect(() => {
    const findParentKey = (items, path) => {
      for (const item of items) {
        if (item.url === path) {
          return item.id.toString();
        }
        if (item.children) {
          const childKey = findParentKey(item.children, path);
          if (childKey) {
            return item.id.toString();
          }
        }
      }
      return null;
    };

    const parentKey = findParentKey(sidebarItems, location.pathname);
    if (parentKey) {
      setOpenKeys([parentKey]);
    }
  }, [location.pathname]);

  const onOpenChange = (keys) => {
    setOpenKeys(keys);
  };

  return (
    <Sider
      width={200}
      className="site-layout-background d-none d-lg-block"
      style={{
        borderRight: "2px solid #e9edf4",
        position: "fixed",
        height: "100vh",
        overflowY: "auto",
      }}
    >
      <Menu
        mode="inline"
        selectedKeys={[selectedKey]}
        openKeys={openKeys}
        onOpenChange={onOpenChange}
        style={{ height: "100%", borderRight: 0 }}
        theme="light"
      >
        {sidebarItems.map((menu) =>
          menu.children && menu.children.length > 0 ? (
            <SubMenu
              key={menu.id}
              icon={menu.icon}
              style={{
                color:
                  selectedKey === menu.id.toString() ||
                  menu.children.some(
                    (child) => selectedKey === child.id.toString()
                  )
                    ? "var(--primary-color)"
                    : "#6d758a",
                backgroundColor:
                  selectedKey === menu.id.toString() ||
                  menu.children.some(
                    (child) => selectedKey === child.id.toString()
                  )
                    ? "#E5D6F3"
                    : "#ffffff",
              }}
              title={<span style={{ color: "#6d758a" }}>{menu.label}</span>}
            >
              {menu.children.map((item) => (
                <Menu.Item
                  key={item.id}
                  icon={item.icon}
                  style={{
                    color:
                      selectedKey === item.id.toString()
                        ? "var(--primary-color)"
                        : "#6d758a",
                    backgroundColor:
                      selectedKey === item.id.toString()
                        ? "#E5D6F3"
                        : "#ffffff",
                  }}
                >
                  <Link
                    className="link-unstyled text-decoration-none"
                    to={item.url}
                  >
                    {item.label}
                  </Link>
                </Menu.Item>
              ))}
            </SubMenu>
          ) : (
            <Menu.Item
              key={menu.id}
              icon={menu.icon}
              style={{
                color:
                  selectedKey === menu.id.toString()
                    ? "var(--primary-color)"
                    : "#6d758a",
                backgroundColor:
                  selectedKey === menu.id.toString() ? "#e0dee2" : "#ffffff",
                fontWeight: selectedKey === menu.id.toString() ? "600" : "",
              }}
            >
              <Link className="link-unstyled text-decoration-none" to={menu.url}>
                {menu.label}
              </Link>
            </Menu.Item>
          )
        )}
      </Menu>
    </Sider>
  );
};

export default Sidebar;